export const ABOUT_PATH = "/about";
export const ABOUT_CAREERS = "/about/careers";
export const ABOUT_INVESTOR_RELATIONS = "/about/investorrelations";
export const ABOUT_NEWS_ROOM = "/about/newsroom";
export const ABOUT_WHO_WE_ARE = "/about/whoweare";
export const ACQUIRED_ASSETS_AUTO_LOANS =
  "/acquired-assets/auto-loans-second-hand";
export const ACQUIRED_ASSETS_AUTO_LOANS_LIST =
  "/acquired-assets/auto-loans-second-hand-list";
export const ACQUIRED_ASSETS_PROPERTY = "/acquired-assets/properties-for-sale";
export const ACQUIRED_ASSETS_PROPERTY_LIST =
  "/acquired-assets/properties-for-sale-list";
export const ADVISORIES = "/advisories";
export const AUTO_LOANS_APPLICATION_FORM = "/loans/auto-loan/apply";

export const BUSINESS = "/business";
export const BUSINESS_BILLERS = "/pages/ewbillers";
export const BUSINESS_LOAN_SOLUTION_APPLICATION_FORM =
  "/business/form/business-loan-solution";
export const BUSINESS_CASH_MANAGEMENT = "/business/cash-management";

export const CARDS_DEBIT_CARDS = "/cards/debit-card";
export const CARDS_PREPAID_CARDS = "/cards/prepaid-card";
export const CARDS_CREDIT_CARDS = "/creditcards";
export const CONTACT_US = "/contactus";

export const DEPOSITS_LANDING_PAGE = "/deposits";
export const DEPOSITS_SAVING_PAGE = "/deposits/savings";
export const DEPOSITS_CHECKING_PAGE = "/deposits/checking";
export const DEPOSITS_TIERED_PAGE = "/deposits/tiered-deposit";
export const DEPOSITS_TIME_DEPOSIT = "/deposits/time-deposit";
export const DEPOSITS_FOREIGN_CURRENCY_DEPOSIT =
  "/deposits/foreign-currency-deposit";
export const DXP_LANDING_PAGE = "/easyway-app";
export const OTHER_SERVICES_EWBILLERS = "/ewbillers";

export const EASYWAY_STAND_ALONE_PATH =
  "/pages/introducing-easyway-expanded-transaction-channel";

export const FOREX_RATES_STAND_ALONE_PATH = "/forexrates/store-digitalscreens";

export const INSTAPAY_PESONET = "/instapaypesonet";
export const INVESTMENTS_FIXED_INCOME = "/investments/fixed-income-products";
export const INVESTMENTS_OVERVIEW = "/investments";
export const INVESTMNETS_UITF = "/investments/uitf";
export const INVESTMENTS_TRUST = "/investments/trust-products-and-services";

export const LOANS_OVERVIEW = "/loans";
export const LOANS_AUTO_LOANS = "/loans/auto-loan";
export const LOANS_HOME_LOANS = "/loans/home-loan";
export const LOANS_PERSONAL_LOANS = "/loans/personal-loan";

export const MOBILE_CHECK_DEPOSIT_PAGE = `/mobile-check-deposit`;

export const PRIVACY_STATEMENT = "/privacystatement";

export const REQUEST_FOR_CALLBACK_PATH = "/request-for-callback/";
export const REQUEST_FOR_CALLBACK_DEPOSIT_PAGE = `${REQUEST_FOR_CALLBACK_PATH}deposit-page`;
export const REQUEST_FOR_INVESTMENT_PAGE = `${REQUEST_FOR_CALLBACK_PATH}investment`;

export const STORE_DIRECTORY = "/storedirectory";
export const STORE_DIRECTORY_ATM = "/storedirectory/atm";
export const TERMS_OF_USE_PATH = "/termsofuse";
export const BUSINESS_INSURANCE = "/business/insurance-solution";
export const BUSINESS_DEPOSIT = "/business/deposit-solution";
export const BUSINESS_CASH_MANAGEMENT_SOLUTION =
  "/business/cash-management-solution";


export const BUSINESS_EASTWEST_EASYBIZ = "/business/easybiz"; //! NEW ADD TO MENU
export const BUSINESS_LOAN_SOLUTION = "/business/loan-solution";
export const BUSINESS_FIXED_INCOME_PRODUCT = "/business/fixed-income-product";
export const BUSINESS_INVESTMENT = "/business/investment-solution";
export const BUSINESS_FOREX_SERVICE = "/business/forex-service-solution";
export const BUSINESS_NEWS = "/business/news-and-insight";
export const BUSINESS_COMPLETE_SOLUTION =
  "/business/complete-business-solution";
export const BUSINESS_THANK_YOU = "/business/thank-you";
export const BUSINESS_NEWS_BY_ID = "/business/news/:id";
export const BUSINESS_LANDING = "/business/landing";

export const BULK_TRANSACTION_CONVERTER =
  "/cash-management-converter-online-form";

export const FEES_AND_CHARGES = "/about/feesandcharges";